export default __webpack_public_path__ + "static/sentinel-banner-action-now-b37a1e4612d51813192c15973b1e0995.jpg";